import type { Command, Specific } from './types'
import { openSurvey, postMessageToFrame } from './widget/widget-dom-api'
import { coreFrameId } from './constant'
import { pairVisitorAndUserIdIfNecessary } from './user-config'
import { addCloseListener, addMountListener } from './listeners'

export const processArgumentsQueue = (instance: Specific) => {
  const currentQueue = [...instance._queue]
  for (const args of currentQueue) {
    processArguments(instance.appId, args)
  }

  Object.defineProperty(instance._queue, 'push', {
    value: function () {
      let i = 0
      let n = this.length
      const l = arguments.length
      for (; i < l; i++, n++) {
        // eslint-disable-next-line prefer-rest-params
        this[n] = arguments[i]
        processArguments(instance.appId, this[n])
      }

      return n
    },
  })
}

const processArguments = (appId: string, args: Command) => {
  // @ts-ignore
  if (!('length' in args) && args.length === 0) {
    return
  }

  const command = args[0]
  switch (command) {
    case 'open': {
      const surveyId = args[1]
      const options = args[2]

      openSurvey({
        appId,
        frameId: coreFrameId,
        surveyId,
        executedFrom: 'code',
        showInitialLoading: true,
        forceOpen: true,
        autoFocus: options?.autoFocus === true,
      })
      break
    }
    case 'preview': {
      const surveyId = args[1]
      const questionId = args[2]

      openSurvey({
        appId,
        frameId: coreFrameId,
        openingQuestionId: questionId,
        surveyId,
        executedFrom: 'code',
        showInitialLoading: true,
        forceOpen: true,
        file: 'preview.html',
        autoFocus: true,
      })
      break
    }
    case 'setUserId': {
      const id = '' + args[1]

      if (id) {
        pairVisitorAndUserIdIfNecessary({
          userId: id,
          appId,
        }).then(userConfig => {
          if (userConfig) {
            postMessageToFrame(coreFrameId, {
              type: 'specific.widget.user',
              ...userConfig,
            })
          }
        })
      }

      break
    }
    case 'addEventListener': {
      const event = args[1]
      const listener = args[2]

      if (!listener || typeof listener !== 'function') {
        return
      }

      switch (event) {
        case 'onClose': {
          addCloseListener(listener)
          break
        }
        case 'onMount': {
          addMountListener(listener)
          break
        }
      }
      break
    }
    case 'removeEventListener': {
      const event = args[1]
      const listener = args[2]

      if (!listener || typeof listener !== 'function') {
        return
      }

      switch (event) {
        case 'onClose': {
          addCloseListener(listener)
          break
        }
        case 'onMount': {
          addMountListener(listener)
          break
        }
      }
      break
    }
  }
}
